<template>
  <k-editor-form v-if="id && list_data && list_type">
    <template #left>
      <k-layout>
        <k-flex c6>
          <div v-for="field in left_other_fields" class="mb-2">
            <div><b>{{field.title}}:</b></div>
            <span v-if="field.type == 'markdown'" v-html="markdownToHtml(get_content_data(field))"></span>
            <span v-else-if="field.type == 'file' && field['content-type'] == 'image'"><a  target="_blank" :href="get_content_data(field)"><img height="200px" contain position="left top" :src="get_content_data(field)" /></a></span>
            <span v-else-if="field.type == 'file'"><a target="_blank" :href="get_content_data(field)">get_content_data(field)</a></span>
            <span v-else-if="field.type == 'checkbox'"><i aria-hidden="true" class="v-icon material-icons theme--dark" :class="checkbox_class(field, get_content_data(field))"> {{checkbox_icon(field, get_content_data(field))}}</i></span>
            <span v-else>{{get_content_data(field)}}</span>
          </div>
        </k-flex>
        <k-flex c6>
         <div v-for="field in right_other_fields">
            <div><b>{{field.title}}:</b></div>
            <span v-if="field.type == 'markdown'" v-html="markdownToHtml(get_content_data(field))"></span>
            <span v-else-if="field.type == 'file' && field['content-type'] == 'image'"><a  target="_blank" :href="get_content_data(field)"><img height="200px" contain position="left top" :src="get_content_data(field)" /></a></span>
            <span v-else-if="field.type == 'file'"><a target="_blank" :href="get_content_data(field)">get_content_data(field)</a></span>
            <span v-else-if="field.type == 'checkbox'"><i aria-hidden="true" class="v-icon material-icons theme--dark" :class="checkbox_class(field, get_content_data(field))">{{checkbox_icon(field, get_content_data(field))}}</i></span>
            <span v-else>{{get_content_data(field)}}</span>
          </div>
        </k-flex>
      </k-layout>
      <k-data-table v-if="id && list_data && list_type"
        :headers="headers"
        :items="fields"
        :pagination.sync="pagination"
        :rows-per-page-items="[5, 15, 25, 50, 100, { text: 'All', value: -1 }]"
        class="elevation-1"
      >
        <template v-slot:items="props">
          <tr>
          <td v-for="i in props.item">
            <template v-if="get_child_content_data(i.id, i.name)">
              <span v-if="i.type == 'markdown'" v-html="markdownToHtml(get_child_content_data(i.id, i.name))"></span>
              <span v-else-if="i.type == 'checkbox'"><i aria-hidden="true" class="v-icon material-icons theme--dark" :class="checkbox_class(i, get_child_content_data(i.id, i.name))">{{checkbox_icon(i, get_child_content_data(i.id, i.name))}}</i></span>
              <span v-else>{{get_child_content_data(i.id, i.name)}}</span>
            </template>
          </td>
        </tr>
        </template>
      </k-data-table>
    </template>
  </k-editor-form>
</template>

<script>
import marked from 'marked'
import {EditorMixin} from '@/lib/mixins.js';

export default {
  mixins: [EditorMixin],
  props: ['id', 'data'],
  data() {
    var ch = this.$cloudserver.channel((typeof(this.id) == "undefined" ? "cms:list_data:create" : "cms:list_data:" + this.id));
    return {
      noActionBar: true,
      ws_channel: ch,
      list_data: this.convert(ch.data),
      pagination: {
        sortBy: 'product_id',
        descending: false,
        rowsPerPage: 25
      },
      child_data: {}
    };
  },
  watch: {
    'ws_channel.data': {
      handler(val) {
        this.list_data = this.convert(val)
      },
      deep: true
    }
  },
  created() {
    this.ws_channel.join();
  },
  computed: {
    markdownRenderer() {
      const renderer = new marked.Renderer();
      const linkRenderer = renderer.link;
      renderer.link = (href, title, text) => {
          const html = linkRenderer.call(renderer, href, title, text);
          return html.replace(/^<a /, '<a target="_blank" rel="nofollow" ');
      };
      return renderer;
    },
    content_list () {
      return _.find(this.content_lists, (cl) => {
        return cl.id == this.data;
      });
    },
    table_rows () {
      return _.get(this.list_type, "fields.table-rows")
    },
    fields () {
      var fields = _.filter(this.list_type.fields["fields"], (field) => { return _.includes(this.table_rows, field.name) });
      return _.flatMap(fields, (field) => {
        var data = _.get(this.list_data, ["data", field.name]);
        if(field.type == "content_select") {
          var fields = this.get_content_list_type_fields(field.content_id);
          this.update_content_data(data)
          return _.reduce(fields, (acc, f) => {
            acc[f.name] = {...f, value: _.get(data, f.name), id: _.get(data, "id")};
            return acc;
          }, {})
        }
        if(field.type == "multiline") {
          return _.flatMap(field.form, (f) => {
            if(f.type == "content_select") {
              var fields = this.get_content_list_type_fields(f.content_id);
              return _.map(data, (d) => {
                var d2 = _.get(d.data, f.name);
                this.update_content_data(d2)
                return _.reduce(fields, (acc, f2) => {
                  acc[f2.name] = {...f2, value: _.get(d2, f2.name), id: _.get(d2, "id")};
                  return acc;
                }, {});
              });
            }
            return {...f, value: _.get(d.data, f.name)}
            
          });
        }
        return {...field, value: data};
      });
    },
    other_fields () {
      var fields = _.filter(this.list_type.fields["fields"], (field) => { return !_.includes(this.table_rows, field.name) });
      return fields
    },
    left_other_fields() {
      return _.filter(this.other_fields, function(field) {
        if (typeof(field.position) == "undefined" || field.position == "left") return true; 
      });
    },
    right_other_fields() {
      return _.filter(this.other_fields, function(field) {
        if (field.position == "right") return true; 
      });
    },
    headers () {
      return _.map(_.first(this.fields), (f) => { return {text: f.title, value: f.name, sortable: false} })
    },
    list_type () {
      var cl = this.content_list;
      return _.find(this.list_types, (lt) => {
        return lt.id == cl.cms_list_type_id;
      });
    },
    content_lists () {
      return Object.values(this.$store.state.cms_lists);
    },
    list_types () {
      return Object.values(this.$store.state.cms_list_types);
    }
  },
  methods: {
    checkbox_icon(field, value) {
      if(value) return field["true-icon"] || "check";
      return field["false-icon"] || "";
    },
    checkbox_class(field, value) {
      if(value) return field["true-color"] || "";
      return field["false-color"] || "";
    },
    get_content_data(field) {
      return _.get(this.list_data, ["data", field.name]);
    },
    get_child_content_data(content_id, field_name, fallback) {
      return _.get(this.child_data, [content_id, field_name]);
    },
    update_content_data(content) {
      var content_id = _.get(content, "id");
      if(content_id) {
        var ws_channel = this.$cloudserver.channel("cms:list_data:"+content_id);
        var on_init_ref = undefined;
        on_init_ref = ws_channel.on("init", (msg) => {
          this.$set(this.child_data, content_id, _.get(msg, "list_data.data"))
          ws_channel.off("init", on_init_ref);
          ws_channel.leave();
        });
        ws_channel.join();
      }
    },
    get_content_list_type_fields(content_id) {
      if(!content_id) return undefined;
      var content_list = _.find(this.content_lists, (cl) => { return cl.id == content_id });
      return _.get(_.find(this.list_types, (lt) => {
        return lt.id == content_list.cms_list_type_id
      }), "fields.fields");
    },
    markdownToHtml(markdown){
      if(!markdown) return "";
      return marked(markdown, { renderer: this.markdownRenderer, breaks: true });
    },
    convert (val) {
      var self = this;
      var data = _.cloneDeep(val.list_data);

      _.each(this.fields, (field) => {

        if(typeof(self.initial) != "undefined") {
          if(!_.isEmpty(self.initial[field.name]) || _.isBoolean(self.initial[field.name])) {
            data.data[field.name] = self.initial[field.name];
          }
        }

        if(field.type == "uuid" && _.isEmpty(data.data[field.name])) {
          data.data[field.name] = uuidv4();
        }

      })
      return data;
    },
    print() {

    }
  }
}
</script>